/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import { Card } from "@mui/material";

import MainHeader from "../mainheader";
import LeaveSummaryTab from "../leaveSummaryTab";
import LeaveBalance from "../LeaveBalance";
import LeaveRequest from "../leaverequest";
import MyLeaveRequest from "../myRequest";
import LeaveTeamList from "../LeaveTeamList";
import LeaveHistory from "../leavehistory";

import { useAuth } from "AuthContext";
import { hasPermission } from "permissionUtils";

/* ─────────────────────────────────────────
   DEFAULT TAB RESOLVER (MY DATA)
───────────────────────────────────────── */
const getDefaultMyDataTab = (permissions = []) => {
  if (hasPermission("LeaveTracker.MyData.LeaveSummary", permissions))
    return "Leave Summary";

  if (hasPermission("LeaveTracker.MyData.LeaveBalance", permissions))
    return "Leave Balance";

  if (hasPermission("LeaveTracker.MyData.LeaveRequest", permissions))
    return "Leave Request";

  if (hasPermission("LeaveTracker.MyData.MyRequest", permissions))
    return "My Request";

  if (hasPermission("LeaveTracker.Mydata.AllLeaveHistory", permissions))
    return "History";

  return "";
};

function LeaveSummary() {
  const { userPermission = [] } = useAuth();

  const [activeTopTab, setActiveTopTab] = useState("");
  const [activeDataTab, setActiveDataTab] = useState("");

  /* ─────────────────────────────────────────
     INIT DEFAULT TABS (RUN ONCE)
  ────────────────────────────────────────── */
  useEffect(() => {
    // 🔐 Do not override user selection
    if (activeTopTab) return;

    if (hasPermission("LeaveTracker.MyData", userPermission)) {
      setActiveTopTab("My Data");
      setActiveDataTab(getDefaultMyDataTab(userPermission));
      return;
    }

    if (hasPermission("LeaveTracker.Team", userPermission)) {
      setActiveTopTab("Team");
    }
  }, [userPermission, activeTopTab]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MainHeader
        activeTopTab={activeTopTab}
        setActiveTopTab={setActiveTopTab}
        activeDataTab={activeDataTab}
        setActiveDataTab={setActiveDataTab}
      />

      {/* ================= MY DATA ================= */}
      {activeTopTab === "My Data" && (
        <>
          {activeDataTab === "Leave Summary" &&
            hasPermission(
              "LeaveTracker.MyData.LeaveSummary",
              userPermission
            ) && <LeaveSummaryTab />}

          {activeDataTab === "Leave Balance" &&
            hasPermission(
              "LeaveTracker.MyData.LeaveBalance",
              userPermission
            ) && (
              <LeaveBalance />
            )}

          {activeDataTab === "Leave Request" &&
            hasPermission(
              "LeaveTracker.MyData.LeaveRequest",
              userPermission
            ) && <LeaveRequest />}

          {activeDataTab === "My Request" &&
            hasPermission(
              "LeaveTracker.MyData.MyRequest",
              userPermission
            ) && <MyLeaveRequest />}

          {activeDataTab === "History" &&
            hasPermission(
              "LeaveTracker.Mydata.AllLeaveHistory",
              userPermission
            ) && <LeaveHistory />}
        </>
      )}

      {/* ================= TEAM ================= */}
      {activeTopTab === "Team" &&
        hasPermission("LeaveTracker.Team", userPermission) && (
          <SoftBox pt={2}>
            <LeaveTeamList />
          </SoftBox>
        )}
    </DashboardLayout>
  );
}

export default LeaveSummary;
